export default __webpack_public_path__ + "static/media/lynnStart.0adb7742.png";